import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vSelect from "vue-select";

Vue.config.productionTip = false;
Vue.component("v-select", vSelect);

Vue.mixin({
  methods: {
    convertToSlug() {
      return this.currentResult["Keeping Them"]
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    }
  }
});

new Vue({
  el: "#app",
  store,
  render: h => h(App)
});
